import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { submitAnswerSmartFillFormBucket } from '~/api/data/smart-fill/mutations';
import {
  loadSmartFillFormBucketQuestions,
  loadSmartFillFormBuckets,
  loadSmartFillCarrierSites,
  shouldRevalidateSmartFillFormBucket
} from '~/api/data/smart-fill/queries';
import { FEATURE_FLAGS } from '~/components/feature-flags';
import { FlagGuard } from '~/components/flag-guard';
import { SmartFillBucketPage } from '~/pages/smart-fill/smart-fill-bucket';
import { SmartFillBucketsPage } from '~/pages/smart-fill/smart-fill-buckets';

export const smartFillRoute: RouteObject = {
  path: 'smart-fill',
  element: <FlagGuard flag={FEATURE_FLAGS.SMART_FILL_ACORD_BUCKETS} to="/app/home" />,
  children: [
    {
      index: true,
      loader: merge({
        formBuckets: loadSmartFillFormBuckets,
        carrierSites: loadSmartFillCarrierSites
      }),
      element: <SmartFillBucketsPage />
    },
    {
      path: ':bucketId',
      loader: merge({
        carrierSites: loadSmartFillCarrierSites,
        formBucketQuestions: loadSmartFillFormBucketQuestions
      }),
      shouldRevalidate: shouldRevalidateSmartFillFormBucket,
      action: byMethod({
        POST: submitAnswerSmartFillFormBucket
      }),
      element: <SmartFillBucketPage />
    }
  ]
};
